<div class="page-title">
  <div [innerHTML]="'AssetsInfo.Title' | translate | safe:'html'" class="title">
  </div>
  <div [innerHTML]="'AssetsInfo.SubTitle' | translate | safe:'html'" class="sub-title">
  </div>
</div>

<ng-container *ngIf="navigationService.isMobile">

  <div class="row w-100">

    <button (click)="openInvestmentInfo()" class="best-mobile-button-in-world">
      {{ 'AssetsInfo.Explanation.Button' | translate }}
      <span class="symbol"> &larr; </span>
    </button>

  </div>

</ng-container>

<form #assetsFormElement [formGroup]="assetsForm">
  <div class="row">
    <section class="data-field col-lg-4">
      <div class="label">
        <span [innerHTML]="'netWorth' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="onLiquidNetWorthChanged()"
                    formControlName="netWorth"
                    name="networth">
          <mat-option *ngFor="let element of netWorthRangeList" value="{{element.rangeValue}}">{{ element.rangeName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredAssetField('netWorth')" class="text-center">
          <p [translate]="'netWorthRequired'">Net worth is required</p>
        </mat-error>
      </mat-form-field>
    </section>
    <div [ngClass]="{'invalid': isRequiredAssetField('netWorth')}" class="field-info-mobile">
      <img alt="info" src="/img/info-icon.svg">
      <div [innerHTML]="'netWorthInfo' | translate | safe:'html'"></div>
    </div>

    <section class="data-field col-lg-4">
      <div class="label">
        <span [innerHTML]="'liquidNetWorth' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="onLiquidNetWorthChanged()"
                    formControlName="liquidNetWorth"
                    name="liquidnetworth">
          <mat-option *ngFor="let element of netWorthLiquidRangeList" value="{{element.rangeValue}}">
            {{ element.rangeName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredAssetField('liquidNetWorth')" class="text-center">
          <p [translate]="'liquidNetWorthRequred'">Net worth is required</p>
        </mat-error>
      </mat-form-field>
    </section>
    <div [ngClass]="{'invalid': isRequiredAssetField('liquidNetWorth')}" class="field-info-mobile">
      <img alt="info" src="/img/info-icon.svg">
      <div [innerHTML]="'liquidNetWorthInfo' | translate | safe:'html'"></div>
    </div>

    <section class="data-field col-lg-4">
      <div class="label">
        <span [innerHTML]="'annualNetIncome' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()"
                    formControlName="annualNetIncome"
                    name="annualnetincome">
          <mat-option *ngFor="let element of annualRangeList" value="{{element.rangeValue}}">{{ element.rangeName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredAssetField('annualNetIncome')" class="text-center">
          <p [translate]="'annualNetIncomeRequired'">Net worth is required</p>
        </mat-error>
      </mat-form-field>
    </section>
    <div [ngClass]="{'invalid': isRequiredAssetField('annualNetIncome')}" class="field-info-mobile">
      <img alt="info" src="/img/info-icon.svg">
      <div [innerHTML]="'annualNetIncomeInfo' | translate | safe:'html'"></div>
    </div>

    <div class="col-lg-4">
      <div *ngIf="!isCorrectLiquidNetWorthSelect()" class="error-container">
        <div *ngIf="!isCorrectLiquidNetWorthSelect()" [innerHTML]="'liquidNetWorthLarge' | translate | safe:'html'"
             class="error"></div>
      </div>

      <div class="field-info">
        <div class="content">
          <img alt="info" src="/img/info-icon.svg">
          <div [innerHTML]="'netWorthInfo' | translate | safe:'html'"></div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div *ngIf="!isCorrectLiquidNetWorth()" class="error-container">
        <div *ngIf="!isCorrectLiquidNetWorth()"
             [innerHTML]="'netWorthLessThanNeed' | translate | safe:'html'"
             class="error"></div>
      </div>

      <div class="field-info">
        <div class="content">
          <img alt="info" src="/img/info-icon.svg">
          <div [innerHTML]="'liquidNetWorthInfo' | translate | safe:'html'"></div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div *ngIf="!isCorrectAnnualIncome()" class="error-container">
        <div *ngIf="!isCorrectAnnualIncome()"
             [innerHTML]="'netWorthLessThanNeed' | translate | safe:'html'"
             class="error"></div>
      </div>

      <div class="field-info">
        <div class="content">
          <img alt="info" src="/img/info-icon.svg">
          <div [innerHTML]="'annualNetIncomeInfo' | translate | safe:'html'"></div>
        </div>
      </div>
    </div>

    <div class="w-100"></div>

    <div *ngIf="isCashAccount()" class="field-info cash">
      <div class="content">
        <img alt="info" src="/img/info-icon.svg">
        <div [innerHTML]="'isCashAccount' | translate | safe:'html'"></div>
      </div>
    </div>
  </div>
</form>
